   
<template>
    <div>
        <a-card title="告警统计" >
        <a-form layout="inline" @submit="handleSubmit" :form="form">
               
            <a-form-model-item  label="请选择日期" prop="searchTimeRange">
            <a-popover v-model="rangevisible" trigger="click" placement="bottom" class="search_range">
                        <template slot="title">
                            <a-input v-model="searchTimeRange" placeholder="" class="date_input date_content" />
                        </template>
                        <template slot="content">
                            <div class="date_content">
                                <a-button type="link" @click="handleTime(1)">今天</a-button>
                                <a-button type="link" @click="handleTime(2)">昨天</a-button>
                                <a-button type="link" @click="handleTime(3)">本周</a-button>
                                <a-button type="link" @click="handleTime(4)">上周</a-button>
                                <a-button type="link" @click="handleTime(5)">本月</a-button>
                                <a-button type="link" @click="handleTime(6)">上月</a-button>
                                <a-button type="link" @click="handleTime(100)">自定义</a-button>

                            </div>
                        </template>
                        <a-button type="normal" style="color:#0070cc" :title="searchTimeRange">
                            {{dateTypeTitle}}
                            <a-icon type="down" style="color: #0070cc" />
                        </a-button>
                    </a-popover>
            </a-form-model-item>
             <a-input v-model="timenumber"  v-show="false" />
            <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
            </a-form-item>

            <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
            </a-button>
          </a-form-item>
        </a-form>

        <a-tabs type="card"  default-active-key="errorcode" @change="callback" style="top:10px;">
            <a-tab-pane key="errorcode" tab="异常码"> 
                  <div  id="chartname1" style="padding-right:20px;border:1px solid gray"> </div> 
           </a-tab-pane>
            <a-tab-pane key="failrate" tab="失败率" force-render>
                 <div  id="chartname2" style="padding-right:20px;border:1px solid gray;top:10px;"> </div>
            </a-tab-pane>
            <a-tab-pane key="timeout" tab="超时">
                <div  id="chartname3" style="padding-right:20px;border:1px solid red；top:10px;"> </div>
            </a-tab-pane>
        </a-tabs>

       </a-card>
        
          
    </div>
          
</template>

<script>
import { mapState } from "vuex";

export default {

    data() {
        return {
            form: this.$form.createForm(this),
            logstorename:'',
            projectname:'',
            dateTypeTitle:'今天',
            rangevisible:false,
            searchTimeRange:'',
            syslist:[],
            total:0,
            timenumber:'',
            pageSize:5,
            page:undefined,
            errorcodeChart:null,
            failrateChart:null,
            timeoutChart:null,
            errorcodeDetailChart:null,
            sumData:[],
            errorDataList:[],
            failDataList:[],
            timeoutDataList:[],
            errorDataDetailList:[],
            chartDetail:null,
            tLoading:false,
            chartSys1:null,
            chartSys2:null,
            chartSys3:null,
            callbackkey:''
        }
    },
    methods: {

        handleSelecter() {
            this.modalState.isShow = true;
        },

        //上级按钮
        callback(key1) {
            console.log("callback===>"+key1);
            this.callbackkey=key1;
            this.drawLine();
        },

        handleSearchReset(){
            this.$store.dispatch({
                type: "alarmmanager/getEmptySearch",
                showMsg: true
            })

            this.appcode='';
            this.handleTime(1);
        },

        handleSubmit(e){
            e.preventDefault();
            this.drawLine();
        },

        handleSearch(){
            this.drawLine();
        },
        
        hide() {
            this.rangevisible = false;
        },
        
        handleTime(t){
            let cRange = {};
            this.timenumber=t;
            if(t != 100){
                cRange = this.G.getRecentDate(t)
                this.dateTypeTitle = cRange.title;
                this.searchTimeRange = cRange.start_time + '~' + cRange.end_time;
                this.searchP.starttime=cRange.start_time;
                this.searchP.endtime=cRange.end_time;
                this.searchP.dateTypeTitle = cRange.title;
                this.searchP.searchTimeRange = cRange.start_time + '~' + cRange.end_time;
                this.hide();

            }
            else{
                cRange = this.G.getRecentDate(7)
                this.searchTimeRange = cRange.start_time + '~' + cRange.end_time;
                this.searchP.starttime=cRange.start_time;
                this.searchP.endtime=cRange.end_time;
                this.dateTypeTitle = "自定义"
            }
        },
        
        drawLine() {
            let urlreq='';
            let that = this;
            let c_params = {};

            c_params = {
                urlparams:false,
                ...this.searchP
            }
       
            urlreq="alarmmanager/queryTotalAnalysisdataList";

            let timeRange = that.searchTimeRange.split('~');
            c_params.starttime = (new Date(timeRange[0]).getTime());
            c_params.endtime = (new Date(timeRange[1]).getTime());

            that.$store.dispatch({
                type: urlreq,
                params:c_params
            }).then((res)=>{
                if(res.status == 200){
                    that.errorDataList = res.data.data.data_error;
                    that.failDataList = res.data.data.data_fail;
                    that.timeoutDataList = res.data.data.data_timeout;

                    document.getElementById("chartname1").style.height = "500px";
                    that.errorcodeChart = that.$echarts.init(document.getElementById("chartname1"));
                    let option1 = that.getErrorcodeOption(that.errorDataList,'异常数');
                    that.errorcodeChart.setOption(option1);

                    document.getElementById("chartname2").style.height = "500px";
                    that.failrateChart = that.$echarts.init(document.getElementById("chartname2"));
                    let option2 = that.getErrorcodeOption(that.failDataList,'失败率');
                    that.failrateChart.setOption(option2);

                    let option3 ='';
                    if(this.callbackkey=='timeout'){
                        document.getElementById("chartname3").style.height = "500px";
                        that.failrateChart = that.$echarts.init(document.getElementById("chartname3"));
                        option3 = that.getErrorcodeOption(that.failDataList,'超时');
                        that.failrateChart.setOption(option3);
                    }

                    that.chartSys1 = this.$echarts.init(document.getElementById("chartname1"));
                    // 窗口大小自适应方案
                    that.chartSys1.setOption(option1);
                    that.chartSys1.off('click');
                    that.chartSys1.on('click', function (params) {
                        if (params.componentType === 'series') {
                            if (params.seriesType === 'pie' && params.name) {
                                console.log("clicked  " + params.name )
                                that.getLogDataPerAppcode_(params.name);
                            }
                        }
                    });

                    that.chartSys2 = this.$echarts.init(document.getElementById("chartname2"));
                    // 窗口大小自适应方案
                    that.chartSys2.setOption(option2);
                    that.chartSys2.off('click');
                    that.chartSys2.on('click', function (params) {
                        if (params.componentType === 'series') {
                            if (params.seriesType === 'pie' && params.name) {
                                console.log("clicked  " + params.name )
                                that.getLogDataPerAppcode_(params.name);
                            }
                        }
                    });

                    if(this.callbackkey=='timeout'){
                        that.chartSys3 = this.$echarts.init(document.getElementById("chartname3"));
                        // 窗口大小自适应方案
                        that.chartSys3.setOption(option3);
                        that.chartSys3.off('click');
                        that.chartSys3.on('click', function (params) {
                            if (params.componentType === 'series') {
                                if (params.seriesType === 'pie' && params.name) {
                                    console.log("clicked  " + params.name )
                                    that.getLogDataPerAppcode_(params.name);
                                }
                            }
                        });
                    }
                   
            
                }
            });

        },

        // 饼形图
        getErrorcodeOption(datalist,title){

            let option = {
                tooltip: {
                    trigger: 'item',
                    formatter: function(params) {
                        let res = '<div class="tooltipbox"><h2 style="color:white">' + params.data.name + '</h2> <p>'+ title +':'+ params.data.value +'</p><p>占比：'+ params.percent +'%</p></div>';
                        return res;
                    },
                },
                legend: {
                    show:true,
                    type: 'scroll',
                    orient: 'vertical',
                    left: '75%',
                    top: 20,
                    bottom: 20,
                },
                series: [
                    {
                        name: '系统',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        // right:'100px',
                        top:'50px',
                        left:'30px',
                        avoidLabelOverlap: false,
                        label: {
                            show: true,
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '20',
                                fontWeight: 'bold',
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: datalist
                    }
                ]
            };

            return option
        },
        
        //  appcode饼图点击事件
        getLogDataPerAppcode(appcode){
            console.log("点击："+appcode)
        },

        // 异常码饼图点击事件
        getLogDataPerAppcode_(appcode){
            console.log(appcode)
            let timenumber=this.timenumber;
            let searchTimeRange=this.searchTimeRange;
            this.$router.push({
                path: "appdetails",
                query:{
                    appcode,
                    timenumber,
                    searchTimeRange
                }
            });
        },
    },
    props:["chartname"],

    computed:{
        ...mapState('alarmmanager', {
            searchP: state => state.searchP,
        })
    },

    mounted() {
        this.handleSearchReset()
        this.handleTime(1);
        this.drawLine()

    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);
    }
}

</script>
<style lang="less" scoped>
    .dashBox{
        min-height: 395px;
        border: 1px solid lightgray;
        padding-bottom: 20px;
        background-color: white;
        margin-bottom: 20px;
    }
    .search_range{
        margin-left: 10px;
    }
</style>